// import React from 'react';
// import UserHeader from '../../components/common/UserHeader';
// import banner from "../../assets/headerBanner.png";
// import FirstCard from '../../components/about/FirstCard';
// import SecondCard from '../../components/about/SecondCard';
// import VideoBanner from '../../components/about/VideoBanner';
// import ThirdCard from '../../components/about/ThirdCard';
// import FourthCard from '../../components/about/FourthCard';
// import FifthCard from '../../components/about/FifthCard';
// import OurBlogs from '../../components/homeComponent/OurBlogs';

// const About = () => {
//   return (
//     <React.Fragment>
//       <div className='mb-6 overflow-hidden'>
//         <UserHeader
//           headerImg={banner}
//           pageName="About Us"
//           mainText="Home"
//         />

//         <FirstCard />
//         {/* <SecondCard />
//         <VideoBanner /> */}
//         <ThirdCard />
//         <FifthCard />
//         <OurBlogs/>
//       </div>
//     </React.Fragment>
//   )
// }

// export default About



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from '../../components/common/SEO'; 
import UserHeader from '../../components/common/UserHeader';
import banner from "../../assets/headerBanner.png";
import FirstCard from '../../components/about/FirstCard';
import SecondCard from '../../components/about/SecondCard';
import VideoBanner from '../../components/about/VideoBanner';
import ThirdCard from '../../components/about/ThirdCard';
import FourthCard from '../../components/about/FourthCard';
import FifthCard from '../../components/about/FifthCard';
import OurBlogs from '../../components/homeComponent/OurBlogs';

const About = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/about/get-about`);
        if (response.data.success && response.data.data.length > 0) {
          setAboutData(response.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching about data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();
  }, []);

  // Helper to strip HTML tags
  const stripHtml = (html) => {
    if (!html) return '';
    const text = html.replace(/<[^>]*>/g, ' ');
    return text.replace(/\s+/g, ' ').trim();
  };

  // Get SEO data from aboutData or use defaults
  const getSeoData = () => {
    if (!aboutData) {
      return {
        title: "About BBSR Services - Expert Business Consultants in India",
        description: "Learn about BBSR Services - our mission, vision, and team of expert consultants providing business solutions since 2015.",
        keywords: "about BBSR Services, business consultants, company registration experts",
        canonical: "https://www.bbsrservices.co.in/about"
      };
    }

    return {
      title: aboutData.metaTitle || `${aboutData.title} | About BBSR Services`,
      description: aboutData.metaDescription || (aboutData.description && aboutData.description.length > 0 
        ? stripHtml(aboutData.description[0]).substring(0, 160) 
        : `Learn about ${aboutData.title} - BBSR Services`),
      keywords: aboutData.metaKeywords || `${aboutData.title}, about BBSR Services, business consultants, company registration experts`,
      canonical: aboutData.canonicalUrl || "https://www.bbsrservices.co.in/about"
    };
  };

  const seoData = getSeoData();

  return (
    <React.Fragment>
      {/* SEO Meta Tags for About Page */}
      <SEO 
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        type="website"
      />

      <div className='mb-6 overflow-hidden'>
        <UserHeader
          headerImg={banner}
          pageName="About Us"
          mainText="Home"
        />

        <FirstCard />
        {/* <SecondCard />
        <VideoBanner /> */}
        <ThirdCard />
        <FifthCard />
        <OurBlogs/>
      </div>
    </React.Fragment>
  );
};

export default About;